var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_2571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1111_2571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0H2.38095C1.06599 0 0 1.07452 0 2.4V15.6C0 16.9255 1.06599 18 2.38095 18H22.619C23.934 18 25 16.9255 25 15.6V2.4C25 1.07452 23.934 0 22.619 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1111_2571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0H2.38095C1.06599 0 0 1.07452 0 2.4V15.6C0 16.9255 1.06599 18 2.38095 18H22.619C23.934 18 25 16.9255 25 15.6V2.4C25 1.07452 23.934 0 22.619 0Z",
    fill: "#E02600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54531 8.6761L4.79531 9.6037L5.12864 7.6393L3.71436 6.2473L5.67031 5.9629L6.54531 4.1749L7.41912 5.9629L9.37507 6.2473L7.9584 7.6393L8.29412 9.6025L6.54531 8.6761ZM10.7144 3.6001H11.9048V4.8001H10.7144V3.6001ZM11.9048 6.0001H13.0953V7.2001H11.9048V6.0001ZM11.9048 8.4001H13.0953V9.6001H11.9048V8.4001ZM10.7144 10.8001H11.9048V12.0001H10.7144V10.8001Z",
    fill: "#FFE000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.619 0.600098H2.38093C1.39471 0.600098 0.595215 1.40599 0.595215 2.4001V15.6001C0.595215 16.5942 1.39471 17.4001 2.38093 17.4001H22.619C23.6052 17.4001 24.4047 16.5942 24.4047 15.6001V2.4001C24.4047 1.40599 23.6052 0.600098 22.619 0.600098Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_2571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.73708f02b104886d061f04f93b3fe5d4.svg";
export { ForwardRef as ReactComponent };